import { faFacebook, faInstagram, IconDefinition } from "@fortawesome/free-brands-svg-icons";

type TSocials = Array<{
  icon: IconDefinition;
  url: string;
}>;
export const SOCIALS = [
  {
    icon: faFacebook,
    url: "https://www.facebook.com/ComfortCutzMobileHairSalon/",
  },
  {
    icon: faInstagram,
    url: "https://www.instagram.com/comfortcutzmobile/",
  },
];
